import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    nav: {
        en: {
            0: 'Mall homepage',
            1: 'Production and R&D',
            2: 'About Us',
            3: 'Its products',
            4: 'Product Center',
            5: 'Contact Us'
        },
        cn: {
            0: '官网首页',
            1: '生产与研发',
            2: '关于我们',
            3: '旗下平台',
            4: '产品中心',
            5: '联系我们',
        },

    },
    lang: 'cn',
    langList: [{ text: '中', value: 'cn' }, { text: 'En', value: 'en' }],
    device: 'pc',
    show: false,
    img: '',
    text: {
        cn: {
            home: {
                title: '厦门油典集团有限公司',
                text1: '致力于发展润滑油事业',
                text2: '积极参与全球化竞争',
            },
            products: {
                productsText1: '线上商城--匠油网',
                productsText2: '代理商平台--油匠网',
                productsText3: '采购平台--炬诚润滑',
                productsTextEn1: 'Online mall',
                productsTextEn2: 'Agency platform',
                productsTextEn3: 'Sourcing platform',
                'swiper-tow': '自研的代理商系统平台',
                'swiper-tow1': '定制专用',
                'swiper-tow-text': '专为油典集团代理商打造的一键式分享平台，自购和分享给他人下单购买均可获得收益。',
                'swiper-tow-text1': '产品售后及服务环节，由公司内部客服团队组成“服务团队”统一维护。（此平台只针对渠道经销商使用，不对终端用户开放）',
                'swiper-three': '自研的代理商系统平台',
                'swiper-three1': '定制专用',


            }
        },
        en: {
            home: {
                title: 'Xiamen Youdian Group Co., Ltd.',
                text1: 'Committed to developing lubricant industry',
                text2: 'Actively participate in global competition'
            }
        }
    }
}
const mutations = {
    setLang(state, newLang) {
        state.lang = newLang.value;
        // state.langText = newLang.text
    },

    setdevice(state, device) {
        state.device = device
    }
};

const actions = {
    changeLang({ commit }, newLang) {
        commit('setLang', newLang);
    },

    setDevice({ commit }, device) {
        commit('setdevice', device)
    },
};



export default new Vuex.Store({
    state,
    mutations,
    actions,
})


// WEBPACK FOOTER //
// ./src/store/index.js